import Vue from "vue"

Vue.prototype.$tConfirm = {}

Vue.prototype.$tConfirm.show = function (msg, okcallback, celcallback) {
  Vue.prototype.$confirm(msg, '', {
    distinguishCancelAndClose: true,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(function () {
    if (okcallback && typeof okcallback == 'function') {
      okcallback();
    }
  }).catch(function () {
    if (celcallback && typeof celcallback == 'function') {
      celcallback();
    }
  });
}

Vue.prototype.$tPrompt = {}

Vue.prototype.$tPrompt.show = function (msg, okcallback, celcallback) {
  Vue.prototype.$prompt(msg, '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  }).then(function ({ value }) {
    if (okcallback && typeof okcallback == 'function') {
      okcallback(value);
    }
  }).catch(function () {
    if (celcallback && typeof celcallback == 'function') {
      celcallback();
    }
  });
}
